import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { styled, Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/system'
import React from 'react'

const LoadingSpinnerContainer = styled('div')({
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 9999,
})

const SpinnerContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
})

const Text = styled(Typography)({
  marginLeft: '1rem',
})

interface LoadingSpinnerProps {
  containedProgress?: boolean
  loadingText: string
  size?: number
  sx?: SxProps<Theme> | undefined
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  containedProgress = false,
  loadingText,
  size = 24,
  sx = {},
}) => {
  if (containedProgress) {
    return (
      <>
        <CircularProgress color="primary" size={size} sx={sx} />
        {loadingText && <Text variant="body1">{loadingText}</Text>}
      </>
    )
  }

  return (
    <LoadingSpinnerContainer>
      <SpinnerContainer>
        <CircularProgress color="primary" size={size} sx={sx} />
        {loadingText && <Text variant="body1">{loadingText}</Text>}
      </SpinnerContainer>
    </LoadingSpinnerContainer>
  )
}

export const LoadingFallback = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        paddingTop: (theme) => theme.spacing(10),
      }}
    >
      <CircularProgress color="primary" aria-label="Loading" />
    </Box>
  )
}
